const pickupSwiper = new Swiper('.member-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 8,
  loop: true,
  navigation: {
    nextEl: '.member-next',
    prevEl: '.member-prev',
    disabledClass: 'swiper-button-disabled',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
  watchOverflow: true,
  breakpoints: {
    768: {
      slidesPerView: '4',
      spaceBetween: 24,
    },
  },
});

const thumbnail = new Swiper('.thumbnail', {
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
});

const slider = new Swiper('.slider', {
  spaceBetween: 10,
  loop: true,
  navigation: {
    nextEl: '.swiper-photo-next',
    prevEl: '.swiper-photo-prev',
  },
  thumbs: {
    swiper: thumbnail,
  },
});
